import styled from 'styled-components';

export const CustomContainerSearch = styled.div`
  /* width: 200px; */
  width: 100%;
  padding: 1rem;
  height: 50px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.COLORS.WHITE};
  transition: 0.2s all;
  input {
    outline: none;
    height: 100%;
    width: 100%;
    border: 0;
  }
  img {
    margin-left: 5px;
    width: 20px;
    height: 20px;
  }
`;
